import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export function Logout24() {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15.0957 16.4451C14.7857 20.0451 12.9357 21.5151 8.8857 21.5151L8.7557 21.5151C4.2857 21.5151 2.4957 19.7251 2.4957 15.2551L2.4957 8.74511C2.4957 4.27511 4.2857 2.48511 8.7557 2.48511L8.8857 2.48511C12.9057 2.48511 14.7557 3.93511 15.0857 7.47511",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.995 12.0046L20.375 12.0046",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.1451 15.355L21.4951 12.005L18.1451 8.65503",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
